//Accepts strictly numbers only.
//export const reNumbers = /^[0-9]\b]+$/;

import { locale } from "dayjs";

//Accepts all text
export const reText = /^([a-zA-Z]{1})+([a-zA-Z0-9?=.*!@#$"“”'‘’%^&*_()+<>,|:;'\\/[\]\-\s]{0,1})+$/;

//Accepts Alphanumerics + Space + Underscores + period + Hypyen + alias + Empty String
// export const alphanum = /^[\s*a-zA-Z0-9-_.@]*$/;

/* Accepts Alphanumerics Support 
   Space, Hypyen, Underscores, period, alias, comma, back slash, square brackets, pipe forward slash Empty String
   Plus, equals, back tick, tilda
*/
export const alphanum = /^[\s*a-zA-Z0-9-_.@,/\[\]|\\+=`~]*$/;

//Accepts numbers, space, empty string.
export const reNumbers = /^[0-9\s]*$/;

//Accepts numbers, space, empty string, decimal point.
//export const reDecimalNumbers = /^\d*\.?\d*$/;
export const reDecimalNumbers = /^(\d{1,3}(,\d{3})*|\d+)?(\.\d{0,2})?$/;

//Accepts numbers, decimal point & comma
export const legalCharacters = /^[0-9.,]+$/;

//Accepts email format
// export const reEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
// export const reEmail = /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/;

//Accepts email format multi dots in between(xxx.xxx.xxx@gmail.com)
export const reEmail = /^[a-zA-Z0-9\.]+[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/;

//RESPONSE OBJECT CARRYING VALIDATION RESULT
const result = {
  value: "",
  errorMessage: "",
};

/**============================================================
 * 1. Ensure textfields fulfills following conditions
 *    a. Not empty
 *    b. Does not exceed max length
 ============================================================*/
export function valudateTextfield({ event, fieldName, fieldVariable, fieldLength = 30, setter, isMandatory = true }) {
  let errorMessage = "";

  if (alphanum.test(event.target.value)) {
    if (event.target.value.length === 0 && isMandatory) errorMessage = "Please provide a reason";
    else if (event.target.value.length > fieldLength) errorMessage = "Exceeded " + fieldLength + " characters";
    else errorMessage = "";

    setter(event.target.value);
  }
  return errorMessage;
}

export function valudateTextfield2({ event, fieldName, fieldVariable, fieldLength = 30, isMandatory = true }) {
  if (alphanum.test(event.target.value)) {
    if (event.target.value.length === 0 && isMandatory) result.errorMessage = "Please provide a reason";
    else if (event.target.value.length > fieldLength) result.errorMessage = "Exceeded " + fieldLength + " characters";
    else result.errorMessage = "";

    result.value = event.target.value;
  }
  return result;
}

/**============================================================
 * 1. Ensure fields accepting moneytary amounts follows format below:
 *    [10 digits].[2 digits]
 *
 * 2. Field appends "." after the 10th number
 *
 * 3. Returns: errorMessage Valid - Empty string
 *                          Invalid - "Error String"
 ============================================================*/
export function validateCurrencyField({ event, fieldName, fieldVariable, setter, isMandatory = true }) {
  if (reDecimalNumbers.test(event.target.value)) {
    let errorMessage = "";

    //WHEN NO VALUE PROVIDED
    if (event.target.value.length === 0 && isMandatory) {
      errorMessage = fieldName + " is required. (Eg: 9999999999.99)";
    }

    //WHEN MAX LENGTH EXCEEDED
    // if (event.target.value.length > 13) {
    //   errorMessage = "Invalid currency format.. (Input format 9999999999.99)";
    // }

    //CHECK FORMATTING
    if (event.target.value.length <= 13) {
      let amount = event.target.value.substring(0, 13);
      let dataArr = amount.split(".");
      let currChar = amount.charAt(amount.length - 1);

      if (dataArr.length === 1) {
        //No decimal point
        if (amount.length <= 10) {
          //Allow data to come through without alteration.
        } else if (amount.length > 10 && amount.length <= 13) {
          //Appends data behind decimal point.
          amount = fieldVariable + "." + currChar + "0";
        } else {
          event.target.value = fieldVariable;
        }
      } else {
        //With decimal point - Limit to 2 characters allows after decimal point.
        if (dataArr[1].length > 2) return;
        if (dataArr[1].length <= 2) amount = dataArr[0] + "." + dataArr[1];
        // amount = dataArr[1].length <= 2 ? dataArr[0] + "." + dataArr[1] : amount;
      }

      setter(amount);
    }

    return errorMessage;
  }
}

export function validateCurrencyField2({ event, fieldName, fieldVariable, isMandatory = true }) {
  result.errorMessage = "";

  if (reDecimalNumbers.test(event.target.value)) {
    //WHEN NO VALUE PROVIDED
    if (event.target.value.length === 0 && isMandatory) {
      result.errorMessage = fieldName + " is required. (Eg: 9999999999.99)";
    }

    //CHECK FORMATTING
    if (event.target.value.length <= 13) {
      let amount = event.target.value.substring(0, 13);
      let dataArr = amount.split(".");
      let currChar = amount.charAt(amount.length - 1);

      if (dataArr.length === 1) {
        //No decimal point
        if (amount.length <= 10) {
          //Allow data to come through without alteration.
        } else if (amount.length > 10 && amount.length <= 13) {
          //Appends data behind decimal point.
          amount = fieldVariable + "." + currChar + "0";
        } else {
          event.target.value = fieldVariable;
        }
      } else {
        //With decimal point - Limit to 2 characters allows after decimal point.
        if (dataArr[1].length > 2) return;
        if (dataArr[1].length <= 2) amount = dataArr[0] + "." + dataArr[1];
      }

      result.value = amount;
    }

    return result;
  } else {
    result.errorMessage = "Invalid character";
    return result;
  }
}

/**
 * 1. ATTEMPT ADD COMMA AS THOUSAND SEPARATPR
 * 2. IMMEDIATELY ADD 2 DECIMAL POINT NUMBERR
 */
export function validateCurrencyField3({ event, fieldName, fieldVariable, isMandatory = true }) {
  result.errorMessage = "";

  //Remove comma
  let wholeNumber = 0;
  let fraction = "";
  let data = event.target.value.replace(/,/g, "");

  //Ensure all characters are legal
  if (!legalCharacters.test(data)) {
    if (data === "") result.value = "";

    return result;
  }

  //Ensure max length = 16
  if (data.length > 16) {
    result.errorMessage = fieldName + " exceeded max 13 of digits";
    return result;
  }

  //Ensure only 1 decimal point is allowed
  const dataArr = data.split(".");
  if (data.includes(".") && dataArr.length - 1 > 1) {
    result.errorMessage = fieldName + " already contained 1 decimal point character";
    return result;
  }

  //WHEN INPUT DOESN'T HAVE A DECIMAL - PROCESS WHOLE NUMBERS ONLY
  if (dataArr.length - 1 === 0) {
    //Process whole number
    data = addComma(data.substring(0, 10));

    //After max whole number is achieved, append the next number into fraction.
    if (data.length === 13) data = data + ".";
  }

  //PROCESS FLOATING POINT NUMBERS
  if (data.includes(".") && dataArr.length - 1 === 1) {
    //Process whole number
    wholeNumber = addComma(dataArr[0].substring(0, 10));

    //Process fraction
    fraction = dataArr[1].substring(0, 2);

    //Finalize data
    data = wholeNumber + "." + fraction;
  }

  result.value = data;
  return result;
}

/**
 * Given a string representing a number, add comma as thousand separator
 * Eg. 1234567890 --> 1,234,567,890
 */
export function addComma(wholeNumber) {
  let commaSeparatedWholeNumber = Number(wholeNumber).toLocaleString();
  return commaSeparatedWholeNumber;
}

/**
 * Given a string reprensenting currency in displayable format.
 * Remove it's comma. This enables the result to be convertable to numerics for calculations.
 *
 * Eg. 1,000,000.00 --> 1000000.00
 */
export function removeCommaFromCurrency(stringCurrency) {
  let noCommaCurrency = Number(stringCurrency.replace(/,/g, ""));
  return noCommaCurrency;
}

/**
 * Given a Number format into comma separated currency String
 * Eg.
 * 1000    --> 1,000.00
 * 1000.00 --> 1,000.00
 */
export function convertLocaleString(numberData, locale, fractionDigits) {
  return numberData.toLocaleString(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

export function numberToCurrencyFormat(numericData) {
  let formatted = new Intl.NumberFormat("en-US", { style: "decimal", currency: "USD" });
  return formatted.format(numericData);
}
